import './Notify.scss';
import { IPerson } from '@ms/odsp-datasources/lib/PeoplePicker';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Persona, PersonaSize } from "office-ui-fabric-react/lib/Persona";
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { ClientId, IEngagementExtraData } from '../../interfaces/SharingInterfaces';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import * as React from 'react';
import * as PropTypes from 'prop-types';

export interface INotifyPersonRecipient extends IPerson {
    checked?: boolean;
    personId?: number;
}

export interface INotifyPersonRecipientProps {
    clientId: ClientId;
    person: INotifyPersonRecipient;
    updateCheckboxForPerson: (person: INotifyPersonRecipient) => void;
    engagementExtraData: IEngagementExtraData;
}

export interface INotifyPersonRecipientState {
    person: INotifyPersonRecipient;
}

export class NotifyPersonRecipient extends React.Component<INotifyPersonRecipientProps, INotifyPersonRecipientState> {
    static contextTypes = {
        sharingStore: PropTypes.object.isRequired,
        strings: PropTypes.object.isRequired,
    };

    constructor(props: INotifyPersonRecipientProps, context: any) {
        super(props);

        this.state = {
            person: props.person
        };
    }

    @autobind
    private _onCheckboxChange(ev: React.FormEvent<HTMLElement>, isChecked: boolean) {
        let person = this.props.person;
        person.checked = isChecked;
        this.setState({ person: person });
        this.context.sharingStore.getEngagementHelper().log('Notify.PersonCheckboxClicked', this.props.engagementExtraData);
        this.props.updateCheckboxForPerson(person);
    }

    render(): React.ReactElement<{}> {
        const person = this.state.person;
        return (
            <div className={ css("od-Notify-PickerPersona-container") }>
                <Persona
                    imageUrl={ person.image }
                    text={ person.name }
                    secondaryText={ person.job }
                    showSecondaryText={ !!person.job }
                    size={ PersonaSize.extraSmall }
                    className={ css("od-Notify-PickerPersona") }
                />
                <Checkbox
                    id={ person.email }
                    boxSide={ 'end' }
                    checked={ person.checked }
                    defaultChecked={ false }
                    onChange={ this._onCheckboxChange }
                    className={ css("od-Notify-PickerPersona-checkbox") }
                />
            </div >
        );
    }
}